import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  LinearProgress,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  getPurchaseRequestById,
  getPurchaseExpense,
  getPurchaseDetails,
  getPurchaseRequestPrintById,
} from "src/redux/actions/purchaseRequest.action";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ReportPrintPurchaseRequisition from "src/components/reports/ReportPrintPurchaseRequisition";
import { getBrands } from "src/redux/actions/brand.action";
import _ from "lodash";
import {
  fetchCurrencies,
  findAllBrand,
  findAllDepartment,
} from "src/redux/actions/reference.action";
import Page from "src/components/Page";
import Moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
      // width: "26ch",
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

export default function PrintPurchaseRequisitionComponent() {
  const classes = useStyles();
  const params = useParams();
  const history = useHistory();

  const dispatch = useDispatch();

  const [src, setSrc] = useState();

  const {
    result: {
      countryid,
      currencyid,
      companyid,
      secureid,
      currency_code,
      country,
    },
  } = useSelector((state) => state.loginReducer);

  const brandReducer = useSelector((state) => state.brandReducer);
  const { allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );
  const { currencies } = useSelector((state) => state.referenceReducer);

  const { purchaseRequest, purchaseRequestDetails, purchaseRequesteExpense } =
    useSelector((state) => state.purchaseRequestReducer);

  useEffect(() => {
    dispatch(getPurchaseRequestPrintById(params.id));
    dispatch(getPurchaseDetails(params.id));
    dispatch(getPurchaseExpense(params.id));
    dispatch(getBrands(countryid, companyid, secureid));
    dispatch(fetchCurrencies(currencyid));
    dispatch(findAllDepartment());
    dispatch(findAllBrand());
    return () => {};
  }, []);

  useEffect(() => {
    if (
      purchaseRequest.data &&
      purchaseRequesteExpense.data &&
      purchaseRequestDetails.data &&
      brandReducer.result &&
      allDepartments.data &&
      allBrands.data
    ) {
      const {
        PR_NO,
        CREATED_DATE,
        PR_STATUS,
        POST_DATE,
        REMARK,
        REF_PR_NO,
        UPDATED_AT,
        PR_BRANDID,
        POSTED_EMAIL,
        POSTED_NAME,
        PR_DEPARTID,
        PRINT_TIME,
        PR_COMPIDX_NAME,
        PR_COUNTRYID_NAME,
        ASSIGN_APPROVE_NAME,
        ASSIGN_APPROVE_DATE,
        POSTED_DATE,
        PR_BRANDID_NAME,
        PR_DEPARTID_NAME,
        APPROVED_DATE,
        REQUESTOR_TITLE,
        REQUESTOR_DOA_LEVEL,
        REVIEWER_TITLE,
        REVIEWER_DOA_LEVEL,
        APPROVER_TITLE,
        APPROVER_DOA_LEVEL,
        REVIEWER_NAME,
        REVIEWER_EMAIL,
        REVIEWER_ID,
        REVIEWER_REVIEWED_DATE,
      } = purchaseRequest.data;

      let headers = {};

      let ExpenseAmount = 0;

      if (purchaseRequesteExpense.data) {
        const { AMOUNT } = purchaseRequesteExpense.data;
        ExpenseAmount = AMOUNT;
      }

      headers.REQUESTER = POSTED_NAME;
      headers.REQUESTED_DATE =
        PR_STATUS === 10
          ? Moment().format("DD-MM-YYYY HH:mm:ss")
          : Moment.utc(POSTED_DATE)
              .local("Asia/Bangkok")
              .format("DD-MM-YYYY HH:mm:ss");
      headers.ASSIGN_APPROVE_NAME = ASSIGN_APPROVE_NAME
        ? ASSIGN_APPROVE_NAME
        : "";
      headers.APPROVED_DATE =
        PR_STATUS === 30
          ? Moment.utc(APPROVED_DATE)
              .local("Asia/Bangkok")
              .format("DD-MM-YYYY HH:mm:ss")
          : "";
      headers.EMAIL = POSTED_EMAIL;
      headers.COMPANY = country;
      headers.PR_NO = PR_NO;
      headers.REF_PR_NO = REF_PR_NO;
      headers.CREATED_DATE = CREATED_DATE;
      headers.UPDATED_AT = UPDATED_AT;
      headers.PR_STATUS = PR_STATUS;
      headers.POST_DATE = POST_DATE;
      headers.BUDGET_AMOUNT_CURRENCY = currency_code;
      headers.BRAND_NAME = PR_BRANDID_NAME;
      headers.DEPARTMENT = PR_DEPARTID_NAME;

      headers.REQUESTOR_TITLE = REQUESTOR_TITLE;
      headers.REQUESTOR_DOA_LEVEL = REQUESTOR_DOA_LEVEL;
      headers.REVIEWER_TITLE = REVIEWER_TITLE;
      headers.REVIEWER_DOA_LEVEL = REVIEWER_DOA_LEVEL;
      headers.APPROVER_TITLE = APPROVER_TITLE;
      headers.APPROVER_DOA_LEVEL = APPROVER_DOA_LEVEL;
      headers.REVIEWER_NAME = REVIEWER_NAME;
      headers.REVIEWER_REVIEWED_DATE = REVIEWER_REVIEWED_DATE
        ? Moment.utc(REVIEWER_REVIEWED_DATE)
            .local("Asia/Bangkok")
            .format("DD-MM-YYYY HH:mm:ss")
        : "";

      let baseCurrency = 1;

      let result = _.find(currencies.data, { CURRENCY_ID: currencyid });
      if (result) {
        baseCurrency = result.CURRENCY_EXC_ID;
      }

      headers.PRINT_TYPE = "";

      if ([10, 20, 6].includes(PR_STATUS)) {
        headers.WATERMARK = "DRAFT";
      } else {
        if (PRINT_TIME === 1) {
          headers.PRINT_TYPE = "(Original)";
        } else {
          headers.PRINT_TYPE = `(Re-Print)`;
        }
        headers.WATERMARK = "";
      }

      let footers = {};
      footers.REMARK = REMARK;

      let rows = purchaseRequestDetails.data.map((i) => {
        let brandItem = allBrands.data.find((e) => {
          return e.REF_ID === i.PR_BRANDID;
        });

        let departmentItem = allDepartments.data.find((e) => {
          return e.REF_ID === i.PR_DEPARTID;
        });

        return {
          ...i,
          BUDGET_AMOUNT: baseCurrency * i.PRICE * i.QTY,
          BRAND_NAME: brandItem.REF_NAME,
          DEPARTMENT_NAME: departmentItem.REF_NAME,
        };
      });

      ReportPrintPurchaseRequisition(
        rows,
        allDepartments.data,
        ExpenseAmount,
        headers,
        footers,
        baseCurrency,
        currencies.data
      ).getDataUrl(function (outDoc) {
        setSrc(outDoc);
      });
    }

    return () => {};
  }, [
    purchaseRequest,
    purchaseRequesteExpense,
    purchaseRequestDetails,
    brandReducer,
    params.type,
  ]);

  if (
    allDepartments.isLoading ||
    allBrands.isLoading ||
    currencies.isLoading ||
    purchaseRequest.isLoading ||
    purchaseRequestDetails.isLoading ||
    purchaseRequesteExpense.isLoading
  ) {
    return (
      <Page className={classes.root} title={``}>
        <Container maxWidth="md">
          <Card>
            <CardHeader
              subheader="For the purchase requisition on the system."
              title="Purchase Requesition Print"
            />
            <Divider />
            <CardContent>
              <LinearProgress />
            </CardContent>
          </Card>
        </Container>
      </Page>
    );
  }

  return (
    <Page className={classes.root} title="Print Purchase Requisition">
      <Container maxWidth={false}>
        <Card>
          <CardContent>
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                color="inherit"
                onClick={() => {
                  history.replace("/purchase-requisition-list");
                }}
              >
                Purchase Requisition List
              </Link>
              <Link
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  history.replace(`/edit-purchase-requisition/${params.id}`);
                }}
              >
                Purchase Requisition Form
              </Link>
              <Link color="textPrimary" aria-current="page">
                Print Purchase Requisition ({purchaseRequest.data.PR_NO})
              </Link>
            </Breadcrumbs>
            <Box display="flex" justifyContent="flex-end" m={2}>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  history.replace(`/edit-purchase-requisition/${params.id}`);
                }}
                variant="contained"
                color="secondary"
              >
                <ArrowBackIosIcon /> BACK
              </Button>
            </Box>
            <div style={{ height: "100vh" }} id="pdf-view">
              {src && (
                <iframe title="print" src={src} height="100%" width="100%" />
              )}
            </div>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
